import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { RecentlyUpdatedMacroParams } from '../src/utils/recently-updated-types.ts';

export const RecentlyUpdatedMacroHandler: LoadableType<{
	macroDefaultProps?: Record<string, unknown>;
	macroParams?: RecentlyUpdatedMacroParams;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RecentlyUpdatedMacro" */ '../src/RecentlyUpdatedMacroRenderer.tsx'
			)
		).RecentlyUpdatedMacroRendererHandler,
});
